import { requestProposalReducer, dealProposalReducer, Root, getAllRoutes } from '@makemydeal/activities-request-proposal';
import { requestProposalMiddleware } from './middleware';

export const dealSummaryRoutes = getAllRoutes();

export const requestProposalConfiguration = {
    middleware: requestProposalMiddleware,
    reducer: requestProposalReducer,
    dealProposalReducer: dealProposalReducer,
    routes: Object.values(dealSummaryRoutes),
    routingComponent: Root
};
